import(/* webpackMode: "eager", webpackExports: ["CartPage"] */ "/vercel/path0/apps/web/src/modules/cart/components/cart-page.tsx");
